import UserList from './UserList';

export default () => {

    return (
		<>
			<div className="vh-content-wrap">
				<div className="content-header">
					<h1>사용자관리</h1>
					<h2>사용자를 추가하고 관리할 수 있습니다.</h2>
				</div>
				<div className="content">
					<UserList />
				</div>
			</div>

		</>
    )
}